var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"project-box__links"},_vm._l((_vm.documents),function(document,index){return _c('li',{key:index,attrs:{"data-test-id":"documents"}},[_c('a',{attrs:{"href":document.link,"target":"_blank"}},[_vm._v(" "+_vm._s(document.label)+" ")]),(document.note)?_c('span',[_vm._v(" "+_vm._s(document.note))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }